var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.28 66.4008C30.9828 67.7049 29.2285 68.4521 27.3895 68.4838C25.5504 68.5156 23.7714 67.8293 22.43 66.5708C21.1691 65.2306 20.4813 63.4511 20.513 61.6112C20.5448 59.7714 21.2936 58.0167 22.6 56.7208C27.76 51.5608 38.39 46.9108 40.24 48.7208C42.09 50.5308 37.44 61.2408 32.28 66.4008Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7201 22.5997C58.0172 21.2956 59.7715 20.5484 61.6106 20.5167C63.4497 20.4849 65.2287 21.1712 66.5701 22.4297C67.831 23.7699 68.5188 25.5494 68.487 27.3892C68.4553 29.2291 67.7065 30.9838 66.4001 32.2797C61.2401 37.4397 50.6101 42.0897 48.7601 40.2797C46.9101 38.4697 51.5601 27.7597 56.7201 22.5997Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4001 56.7198C67.077 57.3459 67.6205 58.1022 67.9981 58.9433C68.3757 59.7845 68.5796 60.6933 68.5976 61.6151C68.6156 62.537 68.4472 63.453 68.1027 64.3082C67.7582 65.1635 67.2445 65.9403 66.5926 66.5923C65.9406 67.2443 65.1637 67.7579 64.3084 68.1025C63.4532 68.447 62.5372 68.6153 61.6153 68.5973C60.6935 68.5794 59.7847 68.3755 58.9436 67.9979C58.1024 67.6203 57.3461 67.0767 56.7201 66.3998C51.5601 61.2398 46.9101 50.6098 48.7201 48.7598C50.5301 46.9098 61.2401 51.5598 66.4001 56.7198Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5999 32.2797C21.2959 30.9826 20.5487 29.2283 20.5169 27.3892C20.4852 25.5501 21.1714 23.7711 22.4299 22.4297C23.7701 21.1688 25.5497 20.481 27.3895 20.5128C29.2293 20.5445 30.984 21.2933 32.2799 22.5997C37.4399 27.7597 42.0899 38.3897 40.2799 40.2397C38.4699 42.0897 27.7599 37.4397 22.5999 32.2797Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 87C67.9721 87 87 67.9721 87 44.5C87 21.0279 67.9721 2 44.5 2C21.0279 2 2 21.0279 2 44.5C2 67.9721 21.0279 87 44.5 87Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.b4336678fd2ea8e20244333ce9b0ab37.svg";
export { ForwardRef as ReactComponent };